import React from "react";
import spinner from "./assets/spinner.gif";

const Spinner = () => (
  <>
    <img src={spinner} alt="loader" />
  </>
);

export default Spinner;
